module.exports = __webpack_public_path__ + "static/media/whatwedo.3281b58a.png";